import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';

@Injectable()
export class AdminUserService {
	private baseUrl = environment.apiGateway.apiUrl;
	private apiUrl = '';

	constructor() {
		this.apiUrl = this.baseUrl + 'AdminUser/';
	}

	/**
	 *  update userEmailBy Admin
	 */
	public async updateUserEmailByAdmin(
		id: string,
		userEmail: models.IUpdateUserEmail,
		cancelToken?: CancelToken
	): Promise<models.IAccountUserResponseVM> {
		try {
			const url = this.apiUrl + id;
			const res = await axios.put<models.IAccountUserResponseVM>(url, userEmail, { cancelToken });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Generate temp password
	 */
	public async verifyAndGenerateTempPassword(
		request: models.IAdminPasswordVerificationRequest,
		cancelToken?: CancelToken
	): Promise<models.IGenerateTempPasswordResponse> {
		try {
			const url = this.apiUrl + `TempPassword`;
			const res = await axios.post<models.IGenerateTempPasswordResponse>(url, request, { cancelToken });
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/admin-user.service.ts